var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.244873,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white",
    fillOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.24487,
    width: 76,
    height: 76,
    rx: 38,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.707 18.4298L20.7795 14.7388L27.3304 18.4298L21.0187 21.8831L14.707 18.4298Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3273 25.8135V18.4299L21.0156 21.8833V29.2668L27.3273 25.8135Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8933 29.156C18.7685 28.3203 16.7312 27.002 14.707 25.9316C14.707 23.4306 14.707 20.9295 14.707 18.4299C16.8114 19.5806 18.9143 20.7326 21.0187 21.8833C21.0041 21.8833 21.0945 28.6266 20.8933 29.156Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7344 18.4298L58.8069 14.7388L65.3562 18.4298L59.046 21.8831L52.7344 18.4298Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3571 25.8135V18.4299L59.0469 21.8833V29.2668L65.3571 25.8135Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9206 29.156C56.7958 28.3203 54.7585 27.002 52.7344 25.9316C52.7344 23.4306 52.7344 20.9295 52.7344 18.4299C54.8387 19.5806 56.9417 20.7326 59.046 21.8833C59.0315 21.8833 59.1219 28.6266 58.9206 29.156Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.707 54.506L20.7795 50.8149L27.3304 54.506L21.0187 57.9593L14.707 54.506Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3273 61.8896V54.5061L21.0156 57.9594V65.343L27.3273 61.8896Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8933 65.2321C18.7685 64.3965 16.7312 63.0782 14.707 62.0078C14.707 59.5067 14.707 57.0057 14.707 54.5061C16.8114 55.6567 18.9143 56.8088 21.0187 57.9594C21.0041 57.9594 21.0945 64.7028 20.8933 65.2321Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7344 54.506L58.8069 50.8149L65.3562 54.506L59.046 57.9593L52.7344 54.506Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3571 61.8896V54.5061L59.0469 57.9594V65.343L65.3571 61.8896Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9206 65.2321C56.7958 64.3965 54.7585 63.0782 52.7344 62.0078C52.7344 59.5067 52.7344 57.0057 52.7344 54.5061C54.8387 55.6567 56.9417 56.8088 59.046 57.9594C59.0315 57.9594 59.1219 64.7028 58.9206 65.2321Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3281 21.0242H52.7338",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9722 42.3684L58.8789 50.8151",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9722 29.0989L58.8789 37.5441",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3281 59.0664H52.7338",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9449 42.3684L20.8516 50.8151",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9449 29.2156L20.8516 37.6622",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0316 50.4752C45.7919 50.4752 50.4616 45.8056 50.4616 40.0452C50.4616 34.2849 45.7919 29.6152 40.0316 29.6152C34.2712 29.6152 29.6016 34.2849 29.6016 40.0452C29.6016 45.8056 34.2712 50.4752 40.0316 50.4752Z",
    stroke: "#34CDFA",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0302 23.3472C41.3132 23.3472 42.3533 22.3071 42.3533 21.0241C42.3533 19.741 41.3132 18.7009 40.0302 18.7009C38.7471 18.7009 37.707 19.741 37.707 21.0241C37.707 22.3071 38.7471 23.3472 40.0302 23.3472Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0536 42.3682C60.3366 42.3682 61.3767 41.3281 61.3767 40.045C61.3767 38.762 60.3366 37.7219 59.0536 37.7219C57.7706 37.7219 56.7305 38.762 56.7305 40.045C56.7305 41.3281 57.7706 42.3682 59.0536 42.3682Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8973 42.3682C22.1804 42.3682 23.2205 41.3281 23.2205 40.045C23.2205 38.762 22.1804 37.7219 20.8973 37.7219C19.6143 37.7219 18.5742 38.762 18.5742 40.045C18.5742 41.3281 19.6143 42.3682 20.8973 42.3682Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0302 61.3892C41.3132 61.3892 42.3533 60.3491 42.3533 59.066C42.3533 57.783 41.3132 56.7429 40.0302 56.7429C38.7471 56.7429 37.707 57.783 37.707 59.066C37.707 60.3491 38.7471 61.3892 40.0302 61.3892Z",
    stroke: "#34CDFA",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9615 37.6768H42.1755V36.2476C42.1755 35.6511 41.9669 35.1451 41.5498 34.728C41.1328 34.3109 40.6267 34.1024 40.0303 34.1024C39.4338 34.1024 38.9278 34.3109 38.5107 34.728C38.0936 35.1451 37.8851 35.6511 37.8851 36.2476H36.8132C36.8132 35.3551 37.1267 34.5953 37.7523 33.9697C38.378 33.3441 39.1378 33.0305 40.0303 33.0305C40.9228 33.0305 41.6826 33.3441 42.3082 33.9697C42.9338 34.5953 43.2473 35.3551 43.2473 36.2476V37.6768H44.099C44.4548 37.6768 44.7596 37.8036 45.0119 38.0559C45.2642 38.3082 45.3911 38.613 45.3911 38.9688V45.6772C45.3911 46.033 45.2642 46.3378 45.0119 46.5901C44.7596 46.8424 44.4548 46.9693 44.099 46.9693H35.9601C35.6042 46.9693 35.2994 46.8424 35.0471 46.5901C34.7948 46.3378 34.668 46.033 34.668 45.6772V38.9688C34.668 38.613 34.7948 38.3082 35.0471 38.0559C35.2994 37.8036 35.6042 37.6768 35.9601 37.6768H35.9615ZM35.9615 45.8974H44.1005C44.1646 45.8974 44.2171 45.877 44.258 45.8361C44.2988 45.7953 44.3192 45.7428 44.3192 45.6786V38.9703C44.3192 38.9061 44.2988 38.8536 44.258 38.8128C44.2171 38.772 44.1646 38.7516 44.1005 38.7516H35.9615C35.8973 38.7516 35.8448 38.772 35.804 38.8128C35.7632 38.8536 35.7428 38.9061 35.7428 38.9703V45.6786C35.7428 45.7428 35.7632 45.7953 35.804 45.8361C35.8448 45.877 35.8973 45.8974 35.9615 45.8974ZM40.0303 43.5743C40.3773 43.5743 40.6734 43.4532 40.9169 43.2097C41.1605 42.9661 41.2815 42.6716 41.2815 42.323C41.2815 41.9745 41.1605 41.6799 40.9169 41.4364C40.6734 41.1928 40.3788 41.0718 40.0303 41.0718C39.6817 41.0718 39.3871 41.1928 39.1436 41.4364C38.9001 41.6799 38.779 41.9745 38.779 42.323C38.779 42.6716 38.9001 42.9661 39.1436 43.2097C39.3871 43.4532 39.6817 43.5743 40.0303 43.5743Z",
    fill: "#34CDFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8125 36.2461V37.7219H37.8888L37.8858 36.2461H36.8125Z",
    fill: "#34CDFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseIcon02);
export default __webpack_public_path__ + "static/media/choose_icon02.e12831fa9004e97256eb7364e40d5079.svg";
export { ForwardRef as ReactComponent };